import PageComponent from "components/Page";

import Button from "components/Button";
import ButtonIconSelect from "components/ButtonIconSelect";
import Search from "components/Search";
import MultiSelect from "components/MultiSelect";
import Table from "components/Table";
import FilterPopup from "pages/clients/components/filterPopup";
import FilterBlock from "pages/clients/components/filterBlock";

import './index.less';
import './themes/default.less';

export default class Clients extends PageComponent {

    constructor(props) {
        super(props);

        this.tableMap = {
            photoUid: {
                label: "main.foto",
                type: "avatar",
                size: "40px",
                hideLabel: true,
            },
            fio: {
                label: "client.fio",
                type: "rows",
                rows: [{ key: "profileNumber", style: "text p2 second" }, "lname", "fname, sname"],
                sortKey: "lname",
            },
            birthday: {
                label: "client.dateBirth",
                type: "date",
                format: "DD MMMM YYYY",
            },
            phoneNumber: {
                label: "client.tel",
                type: "phone",
            },
            discount: {
                label: "client.discount",
                type: "percent",
            },
            status: {
                label: "main.status",
                callback: this.clientStatusCell.bind(this),
            },
            lastVisitDate: {
                label: "client.lastVisit",
                type: "date",
            },
            knowAboutClinicId: {
                label: "client.learned",
                type: "select",
                store: "recommendationTypes",
                nameKey: "title",
                emptyValue: 0,
            },
            rating: {
                label: "main.rating",
                type: "rating",
                size: "80px",
                emptyValue: 0,
            }
        };

        const keys = Object.keys(this.tableMap);

        this.state = {
            ...this.state,
            count: 0,
            items: [],
            selected: keys,
            sort: "",
            value: "",
            filter: []

        };

        this.selectItems = keys.map(key => {
            return { id: key, name: this.tr(this.tableMap[key].label) };
        });
    }

    get rightPopupsMap() {
        return {
            "filter": FilterPopup
        };
    }

    clientStatusCell(status, map, { clientIconStatus }) {
        if (status === "PERMANENT" && clientIconStatus !== "REGULAR")
            status = "NOVICE";
        else if (status === "NOVICE" && clientIconStatus === "REGULAR")
            status = "PERMANENT";

        return this._helper.getClientStatus(status, true);
    }

    rowClick(info) {
        this._helper.openClient(info.id);
    }

    componentDidLoad() {
        this.getData();
    }

    async getData() {
        this._helper.showLoading();
        const { sort, value } = this.state;
        const { total_count, data } = await this._request.clients.searchByNamePhone(value || " ", 50, sort, true);
        if (data) {
            this.setState({
                count: total_count,
                items: data,
            });
        }
        this._helper.hideLoading();
    }

    async getDataByConditions(conditions) {
        this._helper.showLoading();
        const cond = [];

        conditions.forEach(it => {
            let { key: field, value } = it;

            if (field === "birthDate") {
                cond.push({
                    field: "birthday",
                    op: ">",
                    value: this._helper.date.toStr(this._helper.date.addDays(value, -1), "YYYY-MM-DD")
                });

                cond.push({
                    field: "birthday",
                    op: "<",
                    value: this._helper.date.toStr(this._helper.date.addDays(value, 1), "YYYY-MM-DD")
                });
            } else if (field === "age") {
                const currentYear = new Date().getFullYear();

                cond.push({
                    field: "birthday",
                    op: ">",
                    value: `${currentYear - value}-01-01`
                });

                cond.push({
                    field: "birthday",
                    op: "<",
                    value: `${currentYear - value}-12-31`
                });
            } else {
                if (field === "sex")
                    value = value === 1 ? "MALE" : "FEMALE";
                else if (field === "doctor")
                    field = "doctorId";
                else if (field === "coordinator")
                    field = "coordinatorId";
                else if (field === "clinic")
                    field = "domainId";


                const row = {
                    field,
                    op: "=",
                    value
                };

                cond.push(row);
            }

        });

        console.log("searchByCondition", cond);


        const { total_count, data } = await this._request.clients.searchByCondition(cond);
        if (data) {
            this.setState({
                count: total_count,
                items: data,
            });
        }
        this._helper.hideLoading();
    }

    onSortChange(sort) {
        this.state.sort = sort;
        this.getData();
    }

    onSearchChange(value) {
        clearTimeout(this.clientsTimer);
        this.clientsTimer = setTimeout(() => {
            clearTimeout(this.clientsTimer);
            this.state.value = value;
            this.getData();
        }, 1000);
    }

    getFiledsLabel(l) {
        let filedsTr = "columns";
        if (l === 1)
            filedsTr = "column";
        else if (l < 5)
            filedsTr = "columna";

        return l + " " + this.tr("main", filedsTr).toLowerCase();
    }

    updateCondition(arr) {
        if (arr.length) {
            this.changeState("filter", arr);
            this.getDataByConditions(arr);
        } else
            this.getData();
    }

    downloadXlsx(prices, validity) {
        const { items } = this.state;
        this._xlsx.reportClients(items);
    }

    renderPage() {
        const { count, items, selected, sort, filter } = this.state;
        const countStr = this.tr("main.inBase") + " " + count;
        const filedslabel = this.getFiledsLabel(selected.length);

        const map = {};
        Object.keys(this.tableMap).forEach(key => {
            if (selected.includes(key))
                map[key] = this.tableMap[key];
        });

        const propsFilter = {
            changeState: this.changeState.bind(this, "filter"),
            filter
        };

        const showDownloadXlsx = this._helper.isDirector() || this._helper.isDepDirector();

        console.log("renderPage", filter);


        return (
            <div className="flex1 flex col gap16">
                <div className="header flex between centerV">
                    <div className="left flex text pageTitle">{this.tr("menu.clients")}</div>
                    <div className="flex gap16">
                        <Button
                            type={"secondary"}
                            size={"small"}
                            label={"main.advancedSearch"}
                            active={false}
                            onClick={this.openRightPopup.bind(this, "filter", propsFilter, this.updateCondition.bind(this))}
                        />
                        {showDownloadXlsx && <ButtonIconSelect
                            typeIcon={"secondary"}
                            translate={true}
                            stopEvent={true}
                            items={[{ name: "Выгрузить в xlsx", onClick: this.downloadXlsx.bind(this) }]}
                        />}
                    </div>
                </div>
                <div className="flex between">
                    <div className="flex gap16">
                        <Search
                            itemStyle="search"
                            placeHolder="clients.search_label"
                            onChange={this.onSearchChange.bind(this)}
                        />
                    </div>
                    <div className="flex centerV gap16">
                        <div className="inBase text p1">{countStr}</div>
                        <MultiSelect
                            min={1}
                            selected={selected}
                            items={this.selectItems}
                            fixedHolder={filedslabel}
                            onChange={this.changeState.bind(this, "selected")}
                        />
                    </div>
                </div>
                <div>
                    {filter.length ? <FilterBlock filter={filter} changeState={propsFilter.changeState} /> : <div></div>}
                </div>
                <Table
                    map={map}
                    items={items}
                    sort={sort}
                    onSortChange={this.onSortChange.bind(this)}
                    rowProps={{
                        click: this.rowClick.bind(this)
                    }}
                />
                <div></div>
            </div>
        );
    }
}
